export default "__VITE_ASSET__DHGERoqv__"